(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.closest('.section-header');
      this.wrapper = this;
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.mainColorScheme = this.wrapper.dataset.mainColorScheme;
      this.overlayColorScheme = this.wrapper.dataset.overlayColorScheme;
      this.headerLayout = this.wrapper.dataset.headerLayout;

      this.setHeaderHeight();
      this.applyTopAppearance();

      this.mediaQuery = window.matchMedia('(max-width: 990px)');
      this.onMediaChange = this.setHeaderHeight.bind(this);
      this.mediaQuery.addEventListener('change', this.onMediaChange);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      if (this.currentScrollTop > 0) {
        this.applySolidAppearance();
      }
    }

    setHeaderHeight() {
      if (!this.header || !this.wrapper) return;

      const headerHeight = this.wrapper.offsetHeight;
      this.header.style.setProperty('--trailpack-header-height', `${headerHeight}px`);
      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
    }

    setColorScheme(colorSchemeClass) {
      if (!colorSchemeClass) return;

      const activeColorScheme = this.wrapper.dataset.activeColorScheme;

      if (activeColorScheme && activeColorScheme !== colorSchemeClass) {
        this.wrapper.classList.remove(activeColorScheme);
      }

      this.wrapper.classList.add(colorSchemeClass);
      this.wrapper.dataset.activeColorScheme = colorSchemeClass;
    }

    applyTopAppearance() {
      if (this.headerLayout === 'overlap') {
        this.setColorScheme(this.overlayColorScheme);
        this.wrapper.classList.remove('trailpack-header-wrapper--solid');
      } else {
        this.setColorScheme(this.mainColorScheme);
        this.wrapper.classList.add('trailpack-header-wrapper--solid');
      }
    }

    applySolidAppearance() {
      this.setColorScheme(this.mainColorScheme);
      this.wrapper.classList.add('trailpack-header-wrapper--solid');
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);

      if (this.mediaQuery && this.onMediaChange) {
        this.mediaQuery.removeEventListener('change', this.onMediaChange);
      }
    }

    createObserver() {
      const observer = new IntersectionObserver((entries, intersectionObserver) => {
        this.headerBounds = entries[0].intersectionRect;
        intersectionObserver.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        this.applySolidAppearance();
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        this.applySolidAppearance();
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.applySolidAppearance();
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.applySolidAppearance();
    }

    reset() {
      if (this.headerIsAlwaysSticky) {
        this.header.classList.remove('shopify-section-header-hidden', 'animate');
        this.applyTopAppearance();
        return;
      }

      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.applyTopAppearance();
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
